module.exports = __webpack_public_path__ + "img/المنطقة الشرقية.951720e0.svg";